export enum ExceedanceTimePeriod {
  Last12Months = 0,
  Last6Months = 1,
  YearToDate = 2,
  SpecificYear = 3,
  Last1Year = 4,
  Last2Years = 5,
  Last3Years = 6,
  Last5Years = 7,
  Custom = 8,
  AllDates = 9,
}

export interface ExceedanceComplianceRequest {
  agentId?: string;
  agentIds?: string[];
  agentGroupIds?: string[];
  oelTypeId?: string;
  timePeriod?: ExceedanceTimePeriod;
  year?: number;
  startDate?: number;
  endDate?: number;
  segId?: string;
  surveyTypeId?: string;
  surveyTypeIds?: string[];
  sampleCategory?: number;
  organizationLevelId?: string;
  jurisdictionId?: string;
  sampleType?: number;
}

export interface ExceedanceComplianceResponse {
  complianceRate: number | null;
  isComplianceRateEvaluable: boolean;
  complianceRateTrend: number | null;
  totalExceedances: number;
  totalExceedancesTrend: number | null;
  totalSamples: number;
  totalSamplesTrend: number | null;
  segsWithExceedances: number;
  segsWithExceedancesTrend: number | null;
  totalSegsSampled: number;
  resolvedStartDate: string;
  resolvedEndDate: string;
  resolvedPriorStartDate: string;
  resolvedPriorEndDate: string;
  exceedancesByAgent: ExceedanceByAgent[];
}

export interface ExceedanceByAgent {
  agentId: string;
  agentName: string;
  samples: number;
  exceedances: number;
  exceedanceRate: number;
  exceedanceRateTrend: number | null;
  highestPoel: number | null;
  highestOelMultiple: string | null;
  highestResultDisplay: string | null;
}

export const EXCEEDING_LAB_RESULT_FILTER_KEY = "ExceedingLabResult";

export interface ExceedingLabResultFilter {
  agentIds?: string[] | null;
  agentGroupIds?: string[] | null;
  oelTypeId?: string | null;
  jurisdictionId?: string | null;
}

export const ALL_EXCEEDING_LAB_RESULTS_FILTER: ExceedingLabResultFilter = {
  agentIds: null,
  agentGroupIds: null,
  oelTypeId: null,
  jurisdictionId: null,
};
